import breakpoints from '../../theme/breakpoints'
import redesignedTheme from '../../theme/news12-redesign'

import css from 'styled-jsx/css'

export default css.div`
  .weather {
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    max-width: 1480px;
    width: 100%;
  }
  
  .top-section, .bottom-section {
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  
  .title-wrapper {
    padding: 12px 0 18px 0;
    margin: 0 auto;
  }
  
  .bottom-right {
    max-width: 100%;
    padding: 12px;
  }
  
  .title {
    font-size: 1.22em;
    text-transform: uppercase;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
    color: ${redesignedTheme.colors.mineShaft};
    border-bottom: 2px solid ${redesignedTheme.colors.lightBlue};
    font-weight: 500;
    width: 100%;
    margin: 0 0 6px 0;
    padding: 0 0 6px 0;
  }
  
  .banner-top {
    padding: 12px;
  }
  
  .banner-middle {
    padding: 12px;
    margin: 0 auto;
  }
  
  .banner-sidebar {
    display: none;
  }
  
  @media only screen and (min-width: ${breakpoints.lg}px) {
    .top-section {
      flex-direction: row;
      align-items: flex-end;
    }
    
    .bottom-section {
      display: flex;
      flex-direction: row;
      width: 100%;
    }
    
    .bottom-right {
      width: 100%;
    }
    
    .title-wrapper {
      margin: 0;
    }
    
    .banner-middle {
      display: none;
    }
    
    .banner-sidebar {
      padding: 12px;
      width: 316px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
`
